// src/routes/PrivateAdminRoute.js
import { Navigate } from "react-router-dom";
import jwtDecode from "jwt-decode";

export default function PrivateAdminRoute({ children }) {
  const token = localStorage.getItem("token");

  if (!token) return <Navigate to="/login" replace />;

  try {
    const decoded = jwtDecode(token);
    const expired = decoded?.exp && decoded.exp * 1000 <= Date.now();

    if (expired) {
      localStorage.removeItem("token");
      localStorage.removeItem("admin");
      return <Navigate to="/login" replace />;
    }

    if (
      decoded.admin === true ||
      decoded.admin === 1 ||
      decoded.admin === "1" ||
      decoded.admin === "true"
    ) {
      return children;
    }
  } catch (err) {
    console.error("Invalid token:", err);
  }

  return <Navigate to="/" replace />;
}
